/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { useTranslation } from 'react-i18next';
import SummaryCard from '../../common/SummaryCard/SummaryCard';
import { actionTypes } from '../../common/SummaryCard/CardContext';

const useStyles = makeStyles(() => {
  return {
    cardMaxWidth: {
      maxWidth: 'unset',
    },
  };
});

export default function BasicFilingCard({ fillingEntries, isSummary, readOnly = false, cardTitle }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <SummaryCard
      Icon={AssignmentIcon}
      cardTitle={cardTitle ?? t('basic-filing.info')}
      subheader=""
      entries={fillingEntries}
      sectionName="submission_basicFilingInfo"
      actionType={isSummary ? null : actionTypes.SUMMARY}
      isSummary={isSummary}
      readOnly={readOnly}
      className={classes}
    />
  );
}
